/**
 * Presentation helpers for a captured AI selection — kept pure so the chip
 * wording is unit-testable independently of the modal.
 */

import type { ResolvedAISelection } from '../../../services/aiSelection';

const PREVIEW_MAX_CHARS = 140;

/** Apps that can name their own selection (Sheets: "B2:D5") win over a count. */
export function selectionSizeLabel(selection: ResolvedAISelection): string {
  if (selection.label) return selection.label;
  const words = selection.text.trim().split(/\s+/).filter(Boolean).length;
  if (words > 1) return `${words} words`;
  return `${selection.text.length} chars`;
}

export function selectionPreview(selection: ResolvedAISelection): string {
  const collapsed = selection.text.replace(/\s+/g, ' ').trim();
  return collapsed.length > PREVIEW_MAX_CHARS
    ? `${collapsed.slice(0, PREVIEW_MAX_CHARS)}…`
    : collapsed;
}

export function describeAISelection(selection: ResolvedAISelection): {
  title: string;
  sizeLabel: string;
  preview: string;
} {
  return {
    title: selection.entityName || 'Selection',
    sizeLabel: selectionSizeLabel(selection),
    preview: selectionPreview(selection),
  };
}
